import { DatadogErrorLevels } from '@bts-web/utils-next-infrastructure';
import { datadogErrorHelper } from '../../common';
import { TFunction } from 'i18next';

type TranslationUtil = TFunction;

export const translateOfferWarnings = (
  recievedWarnings: string[],
  translationUtil: TranslationUtil,
) => {
  return recievedWarnings.map((warning) => {
    const translatedValue: string = translationUtil(
      warning as Parameters<TranslationUtil>[0],
    );

    if (translatedValue === warning) {
      datadogErrorHelper({
        errorMessage: `Warning key not found in translation: ${warning}`,
        errorSeverity: DatadogErrorLevels.HIGH,
      });
    }

    return translatedValue;
  });
};
